import React from 'react';
import EntityTab from '../../controls/EntityTab';

export default function LicenseTypes() {
    return <EntityTab entityType={'LicenseTypes'} />;
}
